import React from 'react';

import { ZoomIn32, ZoomOut32 } from '@carbon/icons-react';

import './Controls.scss';

export interface MapControlsProps {
  zoomIn: any;
  zoomOut: any;
  isZoomed: boolean;
}

const MapControls: React.FC<MapControlsProps> = ({
  zoomIn,
  zoomOut,
  isZoomed = false,
}) => {
  const definePointerZoomIn = () => {
    if (isZoomed) {
      return ' disabled';
    } else {
      return ' enabled';
    }
  };
  const definePointerZoomOut = () => {
    if (!isZoomed) {
      return ' disabled';
    } else {
      return ' enabled';
    }
  };
  const zoomInEnabled = definePointerZoomIn();
  const zoomOutEnabled = definePointerZoomOut();
  return (
    <div className="world-map-leadspace-widget__map--controls">
      <button
        className={
          'world-map-leadspace-widget__map--controls_buttons' +
          zoomInEnabled +
          ' zoom-in'
        }
        onClick={zoomIn}
        disabled={isZoomed}
      >
        <ZoomIn32 />
      </button>
      <button
        className={
          'world-map-leadspace-widget__map--controls_buttons' + zoomOutEnabled
        }
        onClick={zoomOut}
        disabled={!isZoomed}
      >
        <ZoomOut32 />
      </button>
    </div>
  );
};

export default MapControls;
